export default "__VITE_ASSET__d7f0df0d__"